import { environment } from "../../environment";

export const API_ENDPOINTS = {
    PAGES: "/.rest/delivery/pages${path}",
    // Same endpoint type on the component-factory workspace, so factory items can be read
    // headless at all. See feature-component-factory:restEndpoints/delivery/component-factory.
    COMPONENT_FACTORY_PAGES: "/.rest/delivery/component-factory${path}",
    NAVIGATION: "/.rest/delivery/navigation",
    // Header search: full-text ?q= over pages, scoped with @ancestor to the current shop
    // (demo-ecommerce-base:restEndpoints/delivery/pages-search).
    PAGE_SEARCH: "/.rest/delivery/pages-search",
    // Marketing Tags of the Magnolia module, injected by components/magnolia/marketingTags.
    MARKETING_TAGS: "/.rest/delivery/marketing-tags",
    BRANDS: "/.rest/delivery/brands",
    CATEGORIES: "/.rest/delivery/categories",
    PRODUCTS: "/.rest/delivery/products",
    PRODUCT_DECORATION: "/.rest/delivery/product-decoration",
    EXTERNAL_CATEGORIES: "/.rest/external/${source}/categories/${categoryId}",
    EXTERNAL_PRODUCTS: "/.rest/external/${source}/categories/${categoryId}/products",
    EXTERNAL_PRODUCT: "/.rest/external/${source}/products/${productId}",
    TEMPLATE_ANNOTATIONS: "/.rest/template-annotations/v1${path}",
    // magnolia-spa-rendering ships template annotations for `website` only; this is the
    // second endpoint that makes factory items editable in the Pages app preview. Its path
    // starts with v1 on purpose: anonymous URI access exists as /.rest/template-annotations/v1*.
    COMPONENT_FACTORY_ANNOTATIONS: "/.rest/template-annotations/v1-component-factory${path}",
    SITE_INFO: "/.rest/siteInfo/${workspace}${path}",
    // Dynamic forms (GET definition / POST submission). The endpoint only exists when a
    // forms module is installed — the Form component degrades to nothing without it.
    FORMS: "/.rest/forms/v1/forms/${formId}",
    // Smart Connector Marketing (GET form definition / POST lead submission). The
    // endpoints only exist when the marketing module is installed — the Marketing Form
    // component degrades to nothing without them.
    MARKETING_FORM: "/.rest/marketing/${source}/forms/${formId}",
    MARKETING_LEADS: "/.rest/marketing/${source}/forms/${formId}/leads",
    // Reports the reCAPTCHA v3 site key when the endpoint has captcha configured, {} otherwise.
    MARKETING_CAPTCHA: "/.rest/marketing/captcha",
    // Campaign fragments: same endpoint pair as the component factory, on the
    // campaign-manager workspace (see feature-campaign-manager:restEndpoints).
    CAMPAIGN_PAGES: "/.rest/delivery/campaign-manager${path}",
    CAMPAIGN_ANNOTATIONS: "/.rest/template-annotations/v1-campaign-manager${path}",
};

export const getApiEndpoint = (endpoint, params = {}) => {
    if (!API_ENDPOINTS[endpoint]) {
        console.warn("Endpoint is not configured");
        return null;
    }

    const { queryParams, pathParams } = params;

    let e = environment.MAGNOLIA_BASE_URL + API_ENDPOINTS[endpoint];

    if (pathParams) {
        for (const [key, value] of Object.entries(pathParams)) {
            e = e.replace(new RegExp(`\\$\\{${key}\\}`), value);
        }
    }

    if (queryParams) {
        const qpFiltered = Object.fromEntries(Object.entries(queryParams).filter(([key, value]) => key && value));
        const qp = new URLSearchParams(qpFiltered).toString();

        if (qp.length) {
            e = `${e}?${qp}`;
        }
    }

    return e;
};
